import React from "react";

function InfoIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
      <g clip-path="url(#clip0_1_17194)">
        <path d="M6.00009 0.000127627C7.0702 -0.00691003 8.12207 0.277231 9.04309 0.822128C9.93412 1.32842 10.6718 2.06609 11.1781 2.95713C11.723 3.87814 12.0071 4.93002 12.0001 6.00013C12.0071 7.07024 11.723 8.12211 11.1781 9.04313C10.6718 9.93417 9.93412 10.6718 9.04309 11.1781C8.12207 11.723 7.0702 12.0072 6.00009 12.0001C4.92998 12.0072 3.8781 11.723 2.95709 11.1781C2.06744 10.6638 1.33059 9.92212 0.822086 9.02913C0.278472 8.11269 -0.00566754 7.06565 8.56631e-05 6.00013C0.000312772 4.95282 0.274674 3.9238 0.795892 3.0154C1.31711 2.107 2.06703 1.35085 2.97109 0.822128C3.88753 0.278514 4.93456 -0.00562558 6.00009 0.000127627Z" fill="#A2ABB3"/>
        <path d="M5.09863 2.26172V4.07772H6.87263V2.26172H5.09863Z" fill="white" stroke="#A2ABB3" stroke-width="0.2" stroke-miterlimit="10"/>
        <path d="M5.09863 5.00781V9.51481H6.87263V5.00781H5.09863Z" fill="white" stroke="#A2ABB3" stroke-width="0.2" stroke-miterlimit="10"/>
      </g>
      <defs>
        <clipPath id="clip0_1_17194">
          <rect width="12" height="12" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  )
}

export default InfoIcon;
